// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const getNewToken = async () => {
  console.log("Current user:", auth.currentUser); // Debug line

  if (!auth.currentUser) {
    console.log("No user is signed in");
    return null;
  }

  try {
    await auth.currentUser.reload();
    const token = await auth.currentUser.getIdToken(true);
    return token;
  } catch (error) {
    console.error("Error getting token:", error);
    return null;
  }
};

// Make everything globally available for debugging
window.getFirebaseToken = getNewToken;
window.auth = auth;
window.checkAuth = () => {
  console.log("Auth state:", {
    currentUser: auth.currentUser,
    isSignedIn: !!auth.currentUser,
  });
};

// Add auth state listener
onAuthStateChanged(auth, (user) => {
  console.log(
    "Auth state changed:",
    user ? "User is signed in" : "User is signed out",
  );
});
